import { SystemService } from 'src_client/biz/remote/SystemService';

/**
 * キーを限定するUNION型
 */
type LOCAL_STORAGE_KEYS = 'REPORT' | 'VERSION' | 'SHOWN_NEWS_EVENT';

export class LocalData {
  /**
   *
   * @param key LOCAL_STORAGE_KEYSに限定
   * @param val
   */
  static set<T>(key: LOCAL_STORAGE_KEYS, val: T) {
    //valがobjならJSON化する
    if (val instanceof Object) {
      localStorage.setItem(key, JSON.stringify(val));
    } else {
      //存在するキーがあれば上書きする
      localStorage.setItem(key, `${val}`);
    }
  }

  static isExist(key: LOCAL_STORAGE_KEYS): boolean {
    const data = localStorage.getItem(key);
    return data ? true : false;
  }

  static get<T>(key: LOCAL_STORAGE_KEYS): T | null {
    const rawValue = localStorage.getItem(key);
    // console.log(rawValue);
    if (rawValue) {
      try {
        const item: T = JSON.parse(rawValue) as T;
        return item;
      } catch {
        return rawValue as any;
      }
    } else {
      return null;
    }
  }

  static getLocalVersion() {
    return this.get<string>('VERSION') || '0';
  }

  static setLocalVersion(version: string) {
    this.set('VERSION', version);
  }

  static setShownNewsAndEvent(ids: number[]) {
    let result = LocalData.getShownNewsAndEvent();
    if (result) {
      result = result.concat(ids);
      result = Array.from(new Set(result));
    } else {
      result = ids;
    }
    this.set('SHOWN_NEWS_EVENT', result);
  }

  static getShownNewsAndEvent() {
    const result = this.get('SHOWN_NEWS_EVENT') as number[];
    if (!result) return [];
    return result;
  }
}
